module.exports = __webpack_public_path__ + "static/media/jessyywongg.73daece5.mp4";